import PropTypes from 'prop-types';

const propType = {
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  flagEmoji: PropTypes.string,
};

export default { propType };
